<template>
  <div>
    <div class="box">
      <h2>エクセルアップロードで注文機能</h2>
      <p>
        1、RAKUMART無在庫便専用
        発注アップロードファイル　こちらから、ダウンロードしてください。
      </p>
      <p>
        （他のフォーマットが使用しないでください；記入方法がファイルの「sample」をご参考ください。）
      </p>
      <p>２、編集できたファイルが、 こちら　でアップロードしてください。</p>
      <div class="btn">
        <el-upload
          class="upload-demo"
          style="display: inline-block; margin-right: 50px"
          ref="upload"
          action="#"
          :show-file-list="false"
          :before-upload="beforeUpload"
        >
          <el-button slot="trigger" size="small" type="primary"
            >Excelアップロード</el-button
          >
        </el-upload>
        <el-button
          type="primary"
          size="small"
          @click="excelSelectTemplateDownload"
        >
          <a
            :href="
              'https://www.rakumart-2c.com:8080/api/order/excelOrderCreateTemplateDownload?token=' +
              token
            "
            style="color: #fff"
            >Excelテンプレート</a
          ></el-button
        >
        <!-- <el-button type="small ">注文</el-button> -->
      </div>
    </div>
    <!-- 错误信息 -->
    <el-dialog
      title="エラー通知"
      :visible.sync="dialogVisible"
      width="30%"
      center
    >
      <span v-html="errorContent"></span>
      <span slot="footer" class="dialog-footer">
        <el-button type="primary" @click="dialogVisible = false"
          >確定</el-button
        >
      </span>
    </el-dialog>
  </div>
</template>
<script>
import axios from "axios";
export default {
  data() {
    return {
      dialogVisible: false,
      token: localStorage.getItem("token"),
      files: null,
      fileName: "",
      errorContent: "",
    };
  },

  methods: {
    // 下载
    excelSelectTemplateDownload() {
      this.$message.success("操作成功");
    },
    // 上传
    beforeUpload(file) {
      this.files = file;
      const extension = file.name.split(".")[1] === "xlsx";
      const isLt5M = file.size / 1024 / 1024 < 5;
      if (!extension) {
        this.$message.warning("拡張子はxlsxのみ対応");
        return false;
      }
      if (!isLt5M) {
        this.$message.warning("ファイルサイズ５MBまで!");
        return false;
      }
      this.fileName = file.name;
      setTimeout(() => {
        this.submitUpload();
      }, 500);
      return false; // 返回false不会自动上传
    },
    // 上传excel
    submitUpload() {
      let fileFormData = new FormData();
      fileFormData.append("file", this.files, this.fileName);
      // 执行上传excel
      axios({
        url:
          "https://www.rakumart-2c.com:8080/api/order/excelOrderCreate?token=" +
          this.token,
        method: "post",
        data: fileFormData,
        headers: {
          "Content-Type": "application/x-www-form-urlencoded",
        },
      }).then((res) => {
        // if (res.code != 0)
        //   return this.$message.error(
        //     "解決できない場合はチャットより担当者へご連絡ください。"
        //   );
        if (!res.success) {
          this.errorContent = res.data;
          this.dialogVisible = true;
          return;
        }
        this.$message.success(res.msg);
      });
    },
  },
};
</script>
<style lang='scss' scoped>
.box {
  border: 1px solid #ccc;
  width: 600px;
  margin: 100px auto;
  padding: 20px;
  h2 {
    font-size: 30px;
    line-height: 100px;
    text-align: center;
  }
  p {
    line-height: 30px;
  }
  .btn {
    margin: 50px 0;
    text-align: center;
  }
}
</style>